module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cdeiW"))).then(() => parcelRequire('dJXJK'));